
const otsInstallLinks = {
  quest: 'https://www.oculus.com/experiences/quest/3714188128706579/',
  pico: 'https://support.bodyswaps.co/knowledge/install-guide-pico',
  vive: 'https://business.vive.com/appstore/detail/1fa5307d-7ceb-49ef-883a-0c18950725b0',
  ios: 'https://apps.apple.com/us/app/bodyswaps/id1611005211',
  android: 'https://play.google.com/store/apps/details?id=com.bodyswaps.bodyswap',
  pc: 'https://apps.microsoft.com/store/detail/bodyswaps/9MT16NN5Z919?hl=en-gb&gl=GB',
  mac: 'https://apps.apple.com/us/app/bodyswaps/id1611005211',
}

const helpCenterLinks = {
  accessCodes: 'https://support.bodyswaps.co/knowledge',
}


export default {
  Installation: {
    OTS: otsInstallLinks,
  },
  HelpCenter: helpCenterLinks, 
}
